import { QueryObserverResult, useQuery } from '@tanstack/react-query';

import {
  API_QUERY_KEYS,
  getFilterStatuses,
  GetFilterStatusesResponse,
  QueryDefaults,
} from 'api';

export const useFilterStatusesAll = (): QueryObserverResult<GetFilterStatusesResponse> =>
  useQuery([API_QUERY_KEYS.getFilterStatuses], () => getFilterStatuses(), QueryDefaults);
